// @need-translate
export function Operation() {
  return (
    <>
      <header>서비스 운영정책</header>
      <main>
        <section>
          <p>
            본 운영정책은 주식회사 카카오엔터테인먼트(이하 ‘회사’ 또는
            ‘카카오엔터’라 합니다)가 제공하는 ‘카카오페이지’ 서비스(이하 모든
            서비스를 통틀어 ‘서비스’라고만 합니다)를 운영하면서, 서비스 내에
            발생할 수 있는 문제 상황에 대하여 일관성 있게 대처하기 위해 서비스
            운영의 기준과 회원 여러분이 지켜 주셔야 할 세부적인 사항이 규정되어
            있습니다. 운영정책을 지키지 않을 경우 회사가 제공하는 서비스
            일체에서 불이익을 당할 수 있으니 주의 깊게 읽어 주시기 바랍니다.
            또한 본 운영정책에서 사용하는 용어의 뜻은 이용약관의 그것과
            동일합니다.
          </p>
          <p>
            회사는 서비스와 관련된 정책을 개선하고자 회원과의 지속적인
            의견교환을 통해 합리적인 운영정책을 세울 수 있도록 노력하고 있으며,
            그러한 경우 최소 7일 전에 서비스 공지사항을 통해 공지하도록
            하겠습니다.
          </p>
        </section>
        <section>
          <h2>회원의 권리와 의무</h2>
          <ol className="text-theme-solid-60!">
            <li>
              <span>1.</span>
              회원의 권리
              <p className="pt-16pxr! pb-0!">
                <strong>
                  회원은 온라인 고객센터(1일 24시간 가능)등을 통해 서비스에 대한
                  각종 문의를 하실 수 있습니다.
                </strong>
              </p>
            </li>
            <li>
              <span>2.</span>회원의 의무
              <ul>
                <li>
                  회원은 서비스 내에서 법령, 이용약관, 운영정책 등에 위배되는
                  행동 및 다른 회원의 서비스 이용에 방해가 되는 활동을 하지
                  않습니다. 이러한 의무를 위반하는 경우, 회사 내부규정에 따라
                  별도 안내 없이 서비스 이용제한 조치가 이루어질 수 있습니다.
                </li>
                <li>
                  회원은 이용약관, 운영정책 등 규정 및 회사 홈페이지 공지사항
                  등을 수시로 확인하여야 하며, 이를 확인하지 않아 발생하는
                  사항에 대해서는 회사의 도움을 받기 어려울 수 있습니다.
                </li>
                <li>
                  회원은 ‘회사’와 기타 제3자의 저작권 등 지적재산권 침해, 명예
                  손상, 업무를 방해하는 행위, 기타 관련 법령 위반 사항이
                  발견되는 경우 서비스 이용에 제한을 받을 수 있으며 관계 법령에
                  따라 민형사상의 책임이 발생할 수 있습니다.
                </li>
              </ul>
            </li>
          </ol>
        </section>
        <section>
          <h2>서비스 이용제한</h2>
          <section>
            <h3>가. 이용제한 사유에 해당되는 회원의 활동</h3>
            <ol className="text-theme-solid-60!">
              <li>
                <span>1.</span>불법성 활동
                <ul>
                  <li>불법, 사행성 사이트 홍보</li>
                  <li>불법 제품을 판매하거나 홍보</li>
                  <li>
                    악성코드, 바이러스 등의 프로그램을 설치/유포하여 회원의
                    정상적인 서비스 이용을 저해하거나, 회원의 개인정보를
                    탈취하려고 하는 경우
                  </li>
                  <li>
                    버그/시스템 오류 등을 이용하여 서비스를 남용/악용하는 경우
                  </li>
                  <li>
                    방송, 음원, 영화, 만화 등 타인의 저작물을 당사자의 동의 없이
                    공유
                  </li>
                  <li>
                    타인의 저작물을 불법적인 경로로 획득할 수 있는 정보나 방법을
                    제공 (예: 링크경로, 무료 다운로드, 프리서버, CD키 공유,
                    비인가 프로그램 및 사이트 등)
                  </li>
                  <li>
                    타인의 권리에 속하는 상표권, 의장권 등을 무단으로 침해
                  </li>
                  <li>
                    내 게시물(전체 및 일부), 사진, 이미지를 무단 도용(불펌)
                  </li>
                  <li>타인의 개인정보를 포함하고 있는 내용을 작성</li>
                  <li>
                    타인의 개인정보 및 계정, 기기를 도용/탈취하여 서비스를
                    가입하거나, 이용하는 경우
                  </li>
                  <li>
                    개인정보, 로그인 정보(계정 아이디, 비밀번호 등)를 타인과
                    공유, 타인에 판매/양도하는 경우
                  </li>
                  <li>위 항목 외 불법성 활동이라 판단되는 경우</li>
                </ul>
              </li>
              <li>
                <span>2.</span>음란, 청소년 유해활동
                <ul>
                  <li>성매매 관련 정보를 공유하는 행위</li>
                  <li>
                    비정상적인 성적 행위를 미화하거나 구체적으로 표현 또는
                    묘사하는 행위
                  </li>
                  <li>
                    자극적이고 혐오스러운 성적 표현으로 일반인의 성적 수치심을
                    현저히 해할 우려가 있는 행위
                  </li>
                  <li>
                    반인륜적 또는 반인격적인 내용으로 상대방에게 인격적 불쾌감,
                    잔혹감 또는 혐오감을 일으킬 수 있는 행위
                  </li>
                  <li>
                    아동 또는 청소년을 성적 유희의 대상으로 직접적이고
                    구체적으로 묘사하는 행위
                  </li>
                  <li>아동·청소년 대상 성범죄 또는 성범죄 조장 행위</li>
                  <li>
                    모든 회원이 이용 가능한 서비스 또는 게시물 상 청소년에게
                    유해한 과도한 신체 노출 및 음란한 행위 등을 묘사하는 행위
                  </li>
                  <li>
                    기타 법률이 정한 반인류행위 조장 및 아동청소년 성보호에 관한
                    법률에 위반하는 묘사
                  </li>
                </ul>
              </li>
              <li>
                <span>3.</span>저작권 침해
                <ul>
                  <li>
                    저작권자로부터 권리침해 신고가 접수된 저작물에 대한 침해
                    행위
                  </li>
                  <li>
                    회사 서비스를 이용하여 얻은 정보를 적법한 권한 또는 회사의
                    승낙 없이 복제 또는 유통시키거나 영리적으로 사용하는 행위
                  </li>
                  <li>위 행위 외 저작권 침해 행위에 해당될 경우</li>
                </ul>
              </li>
              <li>
                <span>4.</span>미풍양속 위배
                <ul>
                  <li>
                    혐오 스럽거나 폭력성의 내용을 작성하거나 묘사하는 행위
                  </li>
                  <li>
                    게시물, 댓글, 닉네임 작성에 있어 욕설이나 부적절한 언어를
                    사용하는 행위
                  </li>
                  <li>고의적으로 타인을 비방하는 행위</li>
                  <li>
                    자해/자살/살인 등의 내용을 묘사하거나 방조 또는 유인하는
                    행위
                  </li>
                  <li>위 항목 외 미풍양속 위배 행위에 해당될 경우</li>
                </ul>
              </li>
              <li>
                <span>5.</span>도배/광고/홍보스팸활동
                <ul>
                  <li>동일한 내용을 반복적으로 작성하는 경우</li>
                  <li>
                    광고 및 홍보 방문 유도 목적으로 상업적 내용을 작성, 타
                    서비스의 친구신청 등의 활동을 진행할 경우
                  </li>
                  <li>상업적 홍보 광고 가입을 유도하는 행위</li>
                  <li>위 항목 외 도배/광고/홍보스팸 활동을 할 경우</li>
                </ul>
              </li>
              <li>
                <span>6.</span>차별/갈등 조장
                <ul>
                  <li>
                    성별, 종교,장애, 연령, 사회적신분, 인종, 지역, 직업 등을
                    차별하거나 편견을 조장하는 내용을 작성할 경우
                  </li>
                  <li>정치적 선동하는 글을 작성할 경우</li>
                  <li>위 항목 외 차별과 갈등을 조장하는 행위를 할 경우 </li>
                </ul>
              </li>
              <li>
                <span>7.</span>기타
                <ul>
                  <li>
                    서비스의 운영을 방해하거나 악영향을 끼치는 행위를 진행할
                    경우
                  </li>
                  <li>
                    닉네임, 게시물, 댓글 상 회사, 타 업체 또는 저작권자와 관련된
                    사람을 사칭하는 등 서비스의 적정한 이용 외의 다른 목적으로
                    서비스를 악용할 의도가 있다고 판단되는 행위를 할 경우
                  </li>
                  <li>
                    더 이상 서비스를 사용할 의사가 없음을 표명하고 재가입 제한에
                    동의한 후 서비스를 탈퇴한 경우
                  </li>
                  <li>위 항목 외 서비스에서 금지 하는 활동을 한 경우</li>
                </ul>
              </li>
            </ol>
          </section>
          <section>
            <h3>나. 이용제한의 종류</h3>
            <ol className="text-theme-solid-60!">
              <li>
                <span>1.</span>서비스 실이용 제한
                <ul>
                  <li>
                    위 가. 사유에 해당되거나 이용약관을 위반하는 경우, 서비스의
                    이용이 한시적, 영구적으로 일부 또는 전체 제한됩니다.
                  </li>
                  <li>
                    특히, 부적절한 닉네임이라 판단될 경우 닉네임이 강제 변경될
                    수 있습니다.
                  </li>
                  <li>
                    본 운영정책에 반하는 부적절한 게시물 및 댓글은 서비스상
                    노출이 제한될 수 있으며, 조치 횟수 및 사안의 경중 등에 따라
                    서비스 또는 계정의 이용이 제한될 수 있습니다.
                  </li>
                </ul>
              </li>
              <li>
                <span>2.</span>서비스 재가입 제한
                <ul>
                  <li>
                    해당 서비스 탈퇴 후 재가입이 일정 기간동안 제한됩니다.
                  </li>
                </ul>
              </li>
            </ol>
          </section>
          <div>
            <p>
              위 가. 사유 해당 여부 및 그 정도에 따라 단계적으로 이용제한 조치가
              이루어질 수 있습니다. 또한 위 가, 사유에 구체적으로 해당하지
              않더라도 회사의 건전한 서비스 제공에 악영향을 끼치는 행위가 있을
              경우, 이용약관 등에 의거하여 서비스 이용이 제한될 수 있습니다.
              또한 음란 콘텐츠 게시/유포 및 사행성 도박 홍보 등 관련 법률에서
              엄격하게 금지하는 회원의 불법활동에 대해서는 위 가. 사유 해당
              횟수와 관계없이 즉시 영구적으로 서비스 제공이 이루어지지 않을 수
              있습니다. 이러한 이용제한 조치에 대한 이의제기는 조치 통보를 받은
              날로부터 15일 이내에 온라인 문의 등을 통해 언제든지 하실 수
              있습니다. 단, 이의제기 시 회사에 지속적으로 욕설, 음담패설, 협박
              및 기타 회사의 정상적인 업무를 방해하는 등의 행위를 하는 경우,
              회사는 이의제기 사항에 대한 심리 등 후속 절차를 진행하지 않을 수
              있습니다.
            </p>
          </div>
        </section>
        <section>
          <h2>서비스 이용상 신고제도 운영</h2>
          <ol>
            <li>
              <span>1.</span>
              회원은 관련 법령, 서비스 이용약관, 본 운영정책 등에 위배되는
              게시물을 확인한 경우 언제라도 회사에 신고하는 등의 조치를 취할 수
              있습니다.
            </li>
            <li>
              <span>2.</span>
              신고할 때는 신고하려는 게시물의 URL과 해당 게시물의 게시를
              제한해야 하는 사유를 함께 제출해야 합니다. 제출된 게시물 URL과
              신고 사유는 회사 담당자에게 전달되고, 담당자는 이를 바탕으로 게시
              제한 여부를 신중히 검토합니다.
            </li>
            <li>
              <span>3.</span>
              신고자의 생각과 달리 해당 게시물이 명백히 관련 법령, 서비스
              이용약관, 본 운영정책 등을 위반한다고 판단되지 않을 경우에는
              조치가 이루어지지 않을 수 있습니다.
            </li>
            <li>
              <span>4.</span>
              이미 신고사항에 대한 판단이 이루어진 사안이라도, 추후 법원의
              판결이나 권한 있는 행정기관의 처분 등이 있게 되어 이전 판단에
              문제가 있었음이 드러날 경우 회사의 기존 판단이 변경될 수 있습니다.
            </li>
            <li>
              <span>5.</span>
              신고내용을 검토하는 과정에서 해당 게시물에 대한 조치 여부 뿐
              아니라 추가로 해당 회원 계정에 대한 이용제한도 이루어질 수
              있습니다. 이러할 경우 해당 회원의 서비스 이용이력, 운영정책 등
              위반이력 및 그 경중, 관련법령, 서비스 이용약관, 본 운영정책 등을
              종합적으로 고려하여 결정합니다.
            </li>
          </ol>
        </section>
      </main>
      <footer>
        <p>본 운영정책은 2025년 1월 21일부터 적용됩니다.</p>
      </footer>
    </>
  );
}
